export const inputFlightInfo = (state = {}, action) => {
    switch (action.type) {
        case "INPUT_FLIGHT_INFO": {
            return {
                reserveId: action.payload.inputFlightInfo.reserveId,
                outFlightInfo: action.payload.inputFlightInfo.outFlightInfo,
                inFlightInfo: action.payload.inputFlightInfo.inFlightInfo,
                loginId: action.payload.inputFlightInfo.loginId,
                goBoardingDate: action.payload.inputFlightInfo.goBoardingDate,
                backBoardingDate: action.payload.inputFlightInfo.backBoardingDate,
            };
        }
        default: {
            return state;
        }
    }
};
